<template>
  <div class="barBottom">
    <div class="navImg">
      <router-link to="/contact">
        <img src="@/assets/icones/map.png" alt="icone carte" />
        <p>
          <strong>Nous trouver</strong>
          <br />
          {{ $store.state.globalData.name }}
          {{ $store.state.globalData.ville }}
        </p>
      </router-link>
      <a href="tel:0663359042">
        <!-- <img src="@/assets/icones/clef.png" alt="icone jeu de clefs" /> -->
        <i class="fab fa-whatsapp"></i>
        <p>
          <strong>Réservation</strong>
          <br />
          {{ $store.state.globalData.bandeauVertTel }} <br>
          {{ $store.state.globalData.bandeauVertTel2 }}
          <p>(Sms & appels)</p>
        </p>
      </a>
      <a href="mailto:enlebegite@gmail.com">
        <i class="fal fa-envelope fa-2x"></i>
        <p>
          <strong>{{ $store.state.globalData.emailBandeauVert }}</strong>
          <br />
          <!-- {{ $store.state.globalData.telephonePortable }} -->
        </p>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "GreenBarContact",
  data: function () {
    return {};
  },

  methods: {},
};
</script>

<style >
.fa-whatsapp {
  font-size: 40px;
}
</style>
